
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="bg-gradient-to-r from-ai-indigo to-ai-purple py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-white">Join Our Mission</h2>
        <p className="mt-4 text-xl text-indigo-100 max-w-3xl mx-auto">
          Be part of a community dedicated to advancing AI understanding and implementation.
        </p>
        <div className="mt-8 flex justify-center flex-wrap gap-4">
          <Link to="/signup">
            <Button className="bg-white text-ai-indigo hover:bg-gray-100">
              Sign Up Now
            </Button>
          </Link>
          <Link to="/contact">
            <Button className="bg-white text-ai-indigo hover:bg-gray-100">
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
